(function () {
  var footer = document.querySelector('.oddit-footer-main');
  if (!footer) return;

  // One accordion open at a time. The <details> elements share a `name`
  // attribute, which modern browsers enforce natively; this is the fallback
  // for engines that ignore it.
  var accordions = Array.prototype.slice.call(
    footer.querySelectorAll('details[name="oddit-footer-accordion"]')
  );
  accordions.forEach(function (acc) {
    acc.addEventListener('toggle', function () {
      if (!acc.open) return;
      accordions.forEach(function (other) {
        if (other !== acc) other.open = false;
      });
    });
  });

  var form = footer.querySelector('.oddit-footer-main__newsletter-form');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = form.querySelector('.oddit-footer-main__email-input');
    if (!input || !input.value) return;
    // In production this would submit to Shopify customer form.
    // Static preview: just clear the field.
    input.value = '';
  });
})();
